import React from 'react';
import store from '../../../../../../../redux/store';
import BootstrapTable from 'react-bootstrap-table-next';
import { Button, ButtonGroup } from 'react-bootstrap';

const { REACT_APP_MODE, REACT_APP_REQ_PROD_API, REACT_APP_REQ_DEV_API } = process.env;
const ENDPOINT_API = REACT_APP_MODE === 'dev' ? REACT_APP_REQ_DEV_API : REACT_APP_REQ_PROD_API;

export const ScadaShowVarTable = ({ layoutCount, tableDataEntities }) => {
  const token = store.getState().auth.authToken;
  const columns = [
    {
      dataField: 'id',
      text: '#',
      sort: true,
    },
    {
      dataField: 'layout_title',
      text: 'Категория',
      sort: true,
      hidden: layoutCount <= 1 ? true : false,
    },
    {
      dataField: 'title',
      text: 'Наименование',
      sort: true,
    },
    {
      dataField: 'type',
      text: 'Тип',
      sort: true,
    },

    {
      dataField: 'tag_value',
      text: 'Значение',
      sort: true,
      formatter: (cell, _row, _rowIndex) => {
        if (typeof cell === 'number') {
          return cell.toFixed(3);
        }

        return cell;
      },
      style: {
        width: '100px',
      },
    },
    {
      dataField: 'action',
      text: 'Действие',
      sort: true,
      formatter: (_cell, row, _rowIndex) => {
        if (row.actions == 'ReadWrite') {
          if (row.field_type == 'ErrorReset') {
            return (
              <Button
                variant="secondary"
                size="sm"
                onClick={async () => {
                  const value = window.confirm('Вы уверены что хотите сбросить все аварии?');
                  if (value) {
                    try {
                      const form = new FormData();
                      form.append('tag_id', row.id);
                      form.append('value', true);
                      await (
                        await fetch(`${ENDPOINT_API}v1/scada/action`, {
                          headers: {
                            Accept: 'application/json',
                            Authorization: `Bearer ${token}`,
                          },
                          method: 'POST',
                          body: form,
                        })
                      ).text();
                    } catch (e) {
                      alert(e.message);
                    }
                  }
                }}
              >
                Сбросить аварию
              </Button>
            );
          } else if (row.field_type === 'Input') {
            return (
              <Button
                variant="secondary"
                size="sm"
                onClick={async () => {
                  const value = prompt('Укажите необходимое значение');
                  if (value) {
                    try {
                      const form = new FormData();
                      form.append('tag_id', row.id);
                      form.append('value', value);
                      await (
                        await fetch(`${ENDPOINT_API}v1/scada/action`, {
                          headers: {
                            Accept: 'application/json',
                            Authorization: `Bearer ${token}`,
                          },
                          method: 'POST',
                          body: form,
                        })
                      ).text();
                    } catch (e) {
                      alert(e.message);
                    }
                  }
                }}
              >
                Изменить значение
              </Button>
            );
          } else if (row.field_type === 'Boolean') {
            return (
              <>
                <ButtonGroup aria-label="Basic example">
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={async () => {
                      const value = window.confirm('Вы уверены что хотите отправить TRUE?');
                      if (value) {
                        try {
                          const form = new FormData();
                          form.append('tag_id', row.id);
                          form.append('value', true);
                          await (
                            await fetch(`${ENDPOINT_API}v1/scada/action`, {
                              headers: {
                                Accept: 'application/json',
                                Authorization: `Bearer ${token}`,
                              },
                              method: 'POST',
                              body: form,
                            })
                          ).text();
                        } catch (e) {
                          alert(e.message);
                        }
                      }
                    }}
                  >
                    TRUE
                  </Button>
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={async () => {
                      const value = window.confirm('Вы уверены что хотите отправить FALSE?');
                      if (value) {
                        try {
                          const form = new FormData();
                          form.append('tag_id', row.id);
                          form.append('value', false);
                          await (
                            await fetch(`${ENDPOINT_API}v1/scada/action`, {
                              headers: {
                                Accept: 'application/json',
                                Authorization: `Bearer ${token}`,
                              },
                              method: 'POST',
                              body: form,
                            })
                          ).text();
                        } catch (e) {
                          alert(e.message);
                        }
                      }
                    }}
                  >
                    FALSE
                  </Button>
                </ButtonGroup>
              </>
            );
          } else {
            return '';
          }
        }
      },
      style: {
        width: '100px',
      },
    },
  ];

  return (
    <BootstrapTable
      wrapperClasses="table-responsive"
      bordered={false}
      classes="table table-head-custom table-vertical-center overflow-hidden"
      bootstrap4
      keyField="id"
      data={tableDataEntities}
      columns={columns}
    />
  );
};
